module.exports = __webpack_public_path__ + "img/s-circle.e59742ce.svg";